module.exports = __webpack_public_path__ + "static/media/branding_img_right1.da212d67.png";